import React from "react";
import { BooleanField } from "react-admin";

/** @param {import("react-admin").BooleanFieldProps} param0 */
function _BoolNumField(props) {
  return <BooleanField looseValue {...props} />;
}

export const BoolNumField = React.memo(_BoolNumField);
